import { combineReducers, AnyAction } from 'redux';
import { REDUX } from 'constants/index';
import { CarrierTreatyYear, LumenProgramYear } from '../../../types/carrier.types';

const initialCTYState: CarrierTreatyYear[] = [];
const initialLPYState: LumenProgramYear[] = [];

const currentTreaties = (state = initialCTYState, action: AnyAction): CarrierTreatyYear[] => {
    switch (action.type) {
        case `${REDUX.BUSINESS_DATA_CURRENT_TREATIES}/SUCCESS`: {
            return action.payload;
        }
        case `${REDUX.BUSINESS_DATA_CURRENT_TREATIES}/LOADING`: {
            return [];
        }
        case `${REDUX.BUSINESS_DATA_CURRENT_TREATIES}/ERROR`: {
            return [];
        }
        default:
            return state;
    }
};

const allTreaties = (state = initialCTYState, action: AnyAction): CarrierTreatyYear[] => {
    switch (action.type) {
        case `${REDUX.BUSINESS_DATA_ALL_TREATIES}/SUCCESS`: {
            return action.payload;
        }
        case `${REDUX.BUSINESS_DATA_ALL_TREATIES}/LOADING`: {
            return [];
        }
        case `${REDUX.BUSINESS_DATA_ALL_TREATIES}/ERROR`: {
            return [];
        }
        default:
            return state;
    }
};

const currentProgramYears = (state = initialLPYState, action: AnyAction): LumenProgramYear[] => {
    switch (action.type) {
        case `${REDUX.BUSINESS_DATA_CURRENT_PROGRAM_YEARS}/SUCCESS`: {
            return action.payload;
        }
        case `${REDUX.BUSINESS_DATA_CURRENT_PROGRAM_YEARS}/LOADING`: {
            return [];
        }
        case `${REDUX.BUSINESS_DATA_CURRENT_PROGRAM_YEARS}/ERROR`: {
            return [];
        }
        default:
            return state;
    }
};

const allProgramYears = (state = initialLPYState, action: AnyAction): LumenProgramYear[] => {
    switch (action.type) {
        case `${REDUX.BUSINESS_DATA_ALL_PROGRAM_YEARS}/SUCCESS`: {
            return action.payload;
        }
        case `${REDUX.BUSINESS_DATA_ALL_PROGRAM_YEARS}/LOADING`: {
            return [];
        }
        case `${REDUX.BUSINESS_DATA_ALL_PROGRAM_YEARS}/ERROR`: {
            return [];
        }
        default:
            return state;
    }
};

export default combineReducers({
    currentTreaties,
    allTreaties,
    currentProgramYears,
    allProgramYears,
});
